// NotFound.js
import React from "react";
import { Link } from "react-router-dom";
import IP from "../../../images/peck2.jpg";

const NotFound = () => {
  return (
    <div className="container-fluid px-0 w-100 overflow-x-hidden position-absolute">
      <div className="row h-100">
        <div className="col-sm-12 col-md-12 col-lg-6 overflow-x-hidden">
          <img
            src={IP}
            className="mob-IP"
            alt="Indian Panorama"
            width="100%"
            height="100%"
          />
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 second-box h-100 overflow-auto">
          <div className="container">
            <div className="row mt-5">
              <div className="col-2"></div>
              <div className="col-8 mt-5">
                <h1 className="welcome">Oops!</h1>
                <p className="login_with_email">
                  We can't seem to find the page you're looking for.
                </p>
                {/* <p className='error_message'>Error code: 404</p> */}
                <div className="button">
                  <Link to="/" className="login">
                    Go to Homepage
                  </Link>
                </div>
              </div>
              <div className="col-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
